module.exports = __webpack_public_path__ + "static/media/doclad1.e41c0414.pdf";